var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTikTokLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00892 7.87518V7.09466C6.73626 7.05831 6.45922 7.0354 6.17656 7.0354C2.77079 7.0354 0 9.75594 0 13.0997C0 15.1514 1.04396 16.967 2.63692 18.0649C1.60893 16.9813 0.978164 15.5298 0.978164 13.9359C0.978164 10.64 3.67035 7.95166 7.00892 7.87518Z",
    fill: "#00F2EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.15463 16.7053C8.67408 16.7053 9.91367 15.5186 9.96999 14.0399L9.97543 0.83599H12.4323C12.3811 0.564849 12.353 0.285783 12.353 0H8.99726L8.99183 13.2039C8.9355 14.6824 7.69591 15.8692 6.17647 15.8692C5.70414 15.8692 5.25954 15.7534 4.86792 15.551C5.38078 16.2487 6.21349 16.7053 7.15463 16.7053Z",
    fill: "#00F2EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0216 5.31766V4.58365C16.0843 4.58365 15.2112 4.3101 14.4792 3.84137C15.1311 4.57659 16.0164 5.10647 17.0216 5.31766Z",
    fill: "#00F2EA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4794 3.84135C13.7653 3.03602 13.3312 1.98522 13.3312 0.83606H12.4324C12.6691 2.09134 13.4279 3.16832 14.4794 3.84135Z",
    fill: "#FF004F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17651 10.3302C4.62127 10.3302 3.35571 11.5725 3.35571 13.0998C3.35571 14.163 3.97016 15.0872 4.86796 15.5511C4.53337 15.0958 4.33388 14.5389 4.33388 13.9358C4.33388 12.4087 5.59926 11.1662 7.15468 11.1662C7.44505 11.1662 7.7235 11.2132 7.98704 11.2943V7.93073C7.71438 7.89438 7.43733 7.87164 7.15468 7.87164C7.10572 7.87164 7.05747 7.87406 7.00887 7.87526V10.4582C6.74534 10.3772 6.46689 10.3302 6.17651 10.3302Z",
    fill: "#FF004F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0219 5.31775V7.87843C15.2819 7.87843 13.6694 7.33184 12.3532 6.40438V13.0999C12.3532 16.4437 9.58237 19.164 6.1766 19.164C4.86051 19.164 3.64004 18.7565 2.63696 18.065C3.76532 19.2543 5.37249 20 7.15477 20C10.5605 20 13.3313 17.2797 13.3313 13.9359V7.24037C14.6474 8.16783 16.26 8.71442 18 8.71442V5.41973C17.6645 5.41973 17.3375 5.38407 17.0219 5.31775Z",
    fill: "#FF004F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.3532 13.0997V6.40421C13.6693 7.33185 15.2818 7.87826 17.0219 7.87826V5.31758C16.0167 5.10639 15.1314 4.57651 14.4796 3.84129C13.4281 3.16826 12.6692 2.09145 12.4325 0.835999H9.97563L9.97019 14.0399C9.91387 15.5186 8.67428 16.7053 7.15483 16.7053C6.21369 16.7053 5.38098 16.2487 4.86812 15.551C3.97031 15.0871 3.35587 14.1631 3.35587 13.0997C3.35587 11.5726 4.62143 10.3301 6.17667 10.3301C6.46705 10.3301 6.74549 10.3771 7.00903 10.4582V7.87516C3.67046 7.95165 0.978271 10.64 0.978271 13.9359C0.978271 15.5298 1.60903 16.9813 2.63703 18.0648C3.64011 18.7563 4.86057 19.1639 6.17667 19.1639C9.58243 19.1639 12.3532 16.4435 12.3532 13.0997Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTikTokLogo);
export default __webpack_public_path__ + "static/media/TikTokLogo.463ad8c02bd3ba8f50bf8db08a682614.svg";
export { ForwardRef as ReactComponent };